import {createAsyncThunk} from "@reduxjs/toolkit";
import {HOSTNAME} from "../configs/Domain";


// In publicApi.js



export const fetchPortfolioPage = createAsyncThunk(
  'portfolioPages/fetchPortfolioPage',
  async ({pageId, email}, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/pages/public/${pageId}/fetch?email=${email}`);
      if (!response.ok) throw new Error('Failed to delete app data');
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




